import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    // Check if dismissed recently
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed && Date.now() - parseInt(dismissed) < 24 * 60 * 60 * 1000) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // For iOS - show banner after a short delay
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS && !navigator.standalone) {
      setTimeout(() => setShowBanner(true), 3000);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const result = await deferredPrompt.userChoice;
      if (result.outcome === 'accepted') {
        setIsInstalled(true);
      }
      setDeferredPrompt(null);
    }
    setShowBanner(false);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  if (isInstalled || !showBanner) return null;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div className="install-banner" data-testid="install-banner">
      <div className="install-banner-content">
        <img src="/icon-192.png" alt="StoreRuns" className="install-banner-icon" />
        <div className="install-banner-text">
          <strong>Install StoreRuns</strong>
          {isIOS ? (
            <span>Tap <strong>Share</strong> then <strong>"Add to Home Screen"</strong></span>
          ) : (
            <span>Add to your home screen for quick access</span>
          )}
        </div>
      </div>
      <div className="install-banner-actions">
        {!isIOS && (
          <button className="install-btn" onClick={handleInstall} data-testid="install-btn">
            <Download size={16} /> Install
          </button>
        )}
        <button className="install-dismiss" onClick={handleDismiss} data-testid="install-dismiss">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
